export { WishlistItemListDS } from './wishlist-item-list-ds'
export type { WishlistItemListDSProps } from './wishlist-item-list-ds.types'
